import type { LandingKollega } from '@ertekbecslo/kozos/iroda';

export const MAX_KOLLEGA = 6;
const MAX_HOSSZ = 80;

const szoveg = (v: unknown): string | undefined =>
  typeof v === 'string' && v.trim() !== '' ? v.trim().slice(0, MAX_HOSSZ) : undefined;

/** http(s) URL-t megtart (helyben, http-n is látszódjon a fotó); a mentést az RPC validálja. */
function fotoUrl(v: unknown): string | undefined {
  if (typeof v !== 'string') return undefined;
  try {
    const u = new URL(v);
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.toString() : undefined;
  } catch {
    // Érvénytelen URL: szándékosan kihagyjuk, a kolléga fotó nélkül jelenik meg.
    return undefined;
  }
}

/** A `landing_tartalom` jsonb-ből csak a név, szerep és fotó marad (elérhetőség soha). */
export function kollegakNormalizalasa(nyers: unknown): LandingKollega[] {
  const o = nyers && typeof nyers === 'object' && !Array.isArray(nyers) ? (nyers as Record<string, unknown>) : {};
  const lista = Array.isArray(o.kollegak) ? o.kollegak : [];
  return lista.flatMap((k): LandingKollega[] => {
    if (!k || typeof k !== 'object') return [];
    const r = k as Record<string, unknown>;
    const nev = szoveg(r.nev);
    if (!nev) return [];
    const kulcsok: LandingKollega = { nev };
    const szerep = szoveg(r.szerep);
    const foto = fotoUrl(r.fotoUrl);
    if (szerep) kulcsok.szerep = szerep;
    if (foto) kulcsok.fotoUrl = foto;
    return [kulcsok];
  }).slice(0, MAX_KOLLEGA);
}

export function kollegaHiba(k: LandingKollega): string | null {
  const nev = k.nev.trim();
  if (nev === '') return 'A név kötelező.';
  if (nev.length > MAX_HOSSZ) return `A név legfeljebb ${MAX_HOSSZ} karakter.`;
  if ((k.szerep ?? '').trim().length > MAX_HOSSZ) return `A szerep legfeljebb ${MAX_HOSSZ} karakter.`;
  return null;
}

export function atrendezes<T>(lista: T[], index: number, irany: -1 | 1): T[] {
  const cel = index + irany;
  if (index < 0 || index >= lista.length || cel < 0 || cel >= lista.length) return lista;
  const uj = [...lista];
  [uj[index], uj[cel]] = [uj[cel] as T, uj[index] as T];
  return uj;
}

export const MEGHIVAS_HIBA_SZOVEG: Record<string, string> = {
  mar_tag: 'Már tagja az irodának.',
  mas_irodaban: 'Ez a kolléga egy másik iroda aktív tagja. Áthelyezéshez szólj az üzemeltetőnek.',
  sandbox_cim: 'Tesztüzemben csak tesztcímre (…@resend.dev) lehet meghívót küldeni.',
  telefon: 'Csak magyar mobilszám adható meg (+36 20/30/31/50/70).',
  jogosulatlan: 'Ehhez irodavezetői jog kell.',
  mfa: 'Lépj be újra a hitelesítő kóddal.',
};
export const MEGHIVAS_ALAP_HIBA = 'A meghívás nem sikerült, próbáld újra.';
